import {useEffect, useRef, useState} from 'react'

/** Drives the `.reveal` class in index.css; one-shot, never re-triggered on scroll-back. */
export function useReveal<T extends HTMLElement>(rootMargin = '0px 0px -80px 0px') {
  const ref = useRef<T>(null)
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node) return
    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true)
      return
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(true)
          observer.disconnect()
        }
      },
      {threshold: 0.15, rootMargin}
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [rootMargin])

  return {ref, revealed}
}
